import { MembershipPageHeader } from "../components/MembershipPageHeader";
import { MembershipUploadPanel } from "../components/MembershipUploadPanel";

export default function MembershipUploadPage() {
  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <MembershipPageHeader
        title="Membership Bulk Upload"
      />

      <MembershipUploadPanel />
    </div>
  );
}